import { Images } from "@assets/images";

function GoodsInspectionPolicy() {
  return (
    <div className="bg-gray-100 min-h-screen flex justify-center py-8">
      <div className="px-10 py-8 bg-white shadow-md rounded-lg max-w-screen-lg mx-auto">
        <div className="flex justify-center mb-8">
          <img
            className="w-2/3 md:w-1/3"
            src={Images.LogoText.default}
            alt="Logo"
          />
        </div>
        <h1 className="text-3xl font-bold mb-4 text-gray-800 text-center">
          Chính sách kiểm hàng
        </h1>
        <p className=" text-gray-600 ">
          <p className="my-2">
            Trước khi nhận dịch vụ và thanh toán, Quý Khách được quyền kiểm tra
            dịch vụ.
          </p>
          <p className="my-2">
            Sau khi đồng ý với dịch vụ gói cước lựa chon, Quý Khách thanh toán
            và sử dụng dịch vụ.
          </p>
          <p className="my-2">
            Quý Khách vui lòng đọc kỹ thông tin về dịch vụ mình chọn và đối
            chiếu với nội dung dịch vụ được chúng tôi bàn giao qua mail.
          </p>
          <p className="my-2">
            Trường hợp Quý Khách không ưng ý với gói dịch vụ lựa chọn, Quý Khách
            có thể từ chối hoặc nhờ sự hỗ trợ từ nhân viên tư vấn
          </p>
        </p>
      </div>
    </div>
  );
}

export default GoodsInspectionPolicy;
